// import React from 'react';
// import { useLanguage } from '../lib/LanguageContext';
// import { Button } from "./ui/button.jsx";
// import { Globe } from "lucide-react";
// import {
//     DropdownMenu,
//     DropdownMenuContent,
//     DropdownMenuItem,
//     DropdownMenuTrigger,
// } from "./ui/dropdown-menu.jsx";

// const LanguageToggle = () => {
//     const { changeLanguage } = useLanguage();

//     return (
//         <DropdownMenu>
//             <DropdownMenuTrigger asChild>
//                 <Button variant="ghost" size="icon" className="rounded-full bg-white/20 hover:bg-white/40 backdrop-blur-sm">
//                     <Globe className="h-[1.2rem] w-[1.2rem] text-gray-700" />
//                     <span className="sr-only">Toggle language</span>
//                 </Button>
//             </DropdownMenuTrigger>
//             <DropdownMenuContent align="end">
//                 <DropdownMenuItem onClick={() => changeLanguage('id')}>
//                     🇮🇩 Indonesia
//                 </DropdownMenuItem>
//                 <DropdownMenuItem onClick={() => changeLanguage('en')}>
//                     🇬🇧 English
//                 </DropdownMenuItem>
//             </DropdownMenuContent>
//         </DropdownMenu>
//     );
// };

// export default LanguageToggle;

import React from 'react';
// Menggunakan relative path untuk menghindari masalah alias @/
import { useLanguage } from '../lib/LanguageContext';
import { Button } from "./ui/button";

const LanguageToggle = () => {
    const { language, changeLanguage } = useLanguage();

    return (
        <div className="flex items-center p-1 bg-white/40 backdrop-blur-md border border-white/20 rounded-full shadow-sm">
            <Button
                variant="ghost"
                size="sm"
                onClick={() => changeLanguage('id')}
                className={`rounded-full px-3 py-1 h-8 transition-all duration-300 flex items-center gap-2 ${language === 'id'
                        ? 'bg-white text-gray-900 shadow-md transform scale-105 font-bold ring-1 ring-black/5'
                        : 'text-gray-600 hover:bg-white/30 hover:text-gray-900'
                    }`}
                aria-label="Ganti ke Bahasa Indonesia"
            >
                {/* Menggunakan gambar SVG asli agar support di Windows */}
                <img
                    src="https://flagcdn.com/w40/id.png"
                    srcSet="https://flagcdn.com/w80/id.png 2x"
                    alt="Indonesia Flag"
                    className="w-5 h-3.5 object-cover rounded-sm shadow-sm"
                />
                <span className="text-xs font-medium">ID</span>
            </Button>

            <Button
                variant="ghost"
                size="sm"
                onClick={() => changeLanguage('en')}
                className={`rounded-full px-3 py-1 h-8 transition-all duration-300 flex items-center gap-2 ${language === 'en'
                        ? 'bg-white text-gray-900 shadow-md transform scale-105 font-bold ring-1 ring-black/5'
                        : 'text-gray-600 hover:bg-white/30 hover:text-gray-900'
                    }`}
                aria-label="Switch to English"
            >
                {/* Menggunakan gambar SVG asli agar support di Windows */}
                <img
                    src="https://flagcdn.com/w40/gb.png"
                    srcSet="https://flagcdn.com/w80/gb.png 2x"
                    alt="UK Flag"
                    className="w-5 h-3.5 object-cover rounded-sm shadow-sm"
                />
                <span className="text-xs font-medium">EN</span>
            </Button>
        </div>
    );
};

export default LanguageToggle;